import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { arrayMoveImmutable } from "array-move";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import {
  fetchAllQuickTapFeaturedSessions,
  clearQuickTapSessions,
  fetchQuickTapsFeaturedIntro,
  updateQuickTapsFeaturedIntro,
  updateQuickTapFeaturedOrder,
} from "./../../../actions/quickTapsActions";
import QuickTapsFeaturedList from "./QuickTapsFeaturedList/QuickTapsFeaturedList";

const QuickTapsFeaturedTable = () => {
  const dispatch = useDispatch();
  const featured_sessions = useSelector((state) => state.quick_taps.all_quick_tap_sessions);
  const quick_taps_featured_intro = useSelector((state) =>
    state.general_data.general_data ? state.general_data.general_data.quick_taps_featured_intro : ""
  );
  const highlight_index = useSelector((state) => state.highlight_index);

  const [introText, setIntroText] = useState(quick_taps_featured_intro);
  const [sessions, setSessions] = useState(featured_sessions);

  useEffect(() => {
    dispatch(clearQuickTapSessions());
    dispatch(fetchAllQuickTapFeaturedSessions());
    dispatch(fetchQuickTapsFeaturedIntro());
  }, [dispatch]);

  useEffect(() => {
    setIntroText(quick_taps_featured_intro);
  }, [quick_taps_featured_intro]);

  useEffect(() => {
    setSessions(featured_sessions);
  }, [featured_sessions]);

  const handleIntroChange = (e) => {
    setIntroText(e.target.value);
  };

  const handleIntroSave = () => {
    dispatch(updateQuickTapsFeaturedIntro(introText));
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newSessions = arrayMoveImmutable(sessions, oldIndex, newIndex);
    setSessions(newSessions);

    const sort_json = newSessions.map((obj) => obj.id);
    dispatch(updateQuickTapFeaturedOrder(JSON.stringify(sort_json)));
  };

  if (!sessions) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const dragKey = sessions.reduce(
    (accum, val) => (accum += val.id),
    "sort-key"
  );

  return (
    <Box>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            value={introText}
            onChange={handleIntroChange}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            label="Featured Quick Taps Introduction"
            placeholder="Enter featured quick taps introduction text..."
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
              }
            }}
          />
          <Button
            variant="contained"
            onClick={handleIntroSave}
            startIcon={<Save />}
            color="success"
          >
            Update
          </Button>
        </Box>
      </Paper>

      <Paper sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        overflow: 'hidden'
      }}>
        <Box sx={{
          p: 2,
          backgroundColor: '#f0f0f0',
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Featured Quick Taps ({sessions.length})
          </Typography>
        </Box>
        <QuickTapsFeaturedList
          items={sessions}
          highlightIndex={highlight_index}
          onSortEnd={onSortEnd}
          key={dragKey}
        />
      </Paper>
    </Box>
  );
};

export default QuickTapsFeaturedTable;
